import backend from "../utils/backend";
import { SET_UNAUTHED_SUBSCRIPTIONS, SET_UNAUTHED_SUBSCRIPTIONS_SUCCESS, SET_UNAUTHED_SUBSCRIPTIONS_ERROR, GET_USER_DATA, GET_USER_DATA_SUCCESS, GET_USER_DATA_ERROR, UPDATE_USER_SUBSCRIPTIONS, UPDATE_USER_SUBSCRIPTIONS_SUCCESS, UPDATE_USER_SUBSCRIPTIONS_ERROR } from "../constants/actionTypes";

export var getUserData = function getUserData() {
  return function (dispatch) {
    dispatch({
      type: GET_USER_DATA
    });

    return backend.request({
      method: "GET",
      url: "/readers/me/"
    }).then(function (response) {
      dispatch({
        type: GET_USER_DATA_SUCCESS,
        payload: response.data
      });
    }).catch(function (err) {
      dispatch({
        type: GET_USER_DATA_ERROR,
        payload: err
      });
    });
  };
};

export var updateUserSubscriptions = function updateUserSubscriptions(subscriptions, subscription) {
  return function (dispatch) {
    dispatch({
      type: UPDATE_USER_SUBSCRIPTIONS
    });

    return backend.request({
      method: "PATCH",
      url: "/readers/update/",
      data: {
        subscriptions: subscriptions.map(function (s) {
          return s.id;
        }).concat(subscription.id)
      }
    }).then(function () {
      dispatch({
        type: UPDATE_USER_SUBSCRIPTIONS_SUCCESS,
        payload: subscriptions.concat(subscription)
      });
    }).catch(function (err) {
      dispatch({
        type: UPDATE_USER_SUBSCRIPTIONS_ERROR,
        payload: err
      });
    });
  };
};

export var updateUnAuthedSubscriptions = function updateUnAuthedSubscriptions(email, lists) {
  return function (dispatch) {
    dispatch({
      type: SET_UNAUTHED_SUBSCRIPTIONS
    });

    return backend.request({
      method: "POST",
      url: "/readers/unauth-sub/",
      data: {
        email: email,
        lists: lists
      }
    }).then(function () {
      dispatch({
        type: SET_UNAUTHED_SUBSCRIPTIONS_SUCCESS
      });
    }).catch(function (err) {
      dispatch({
        type: SET_UNAUTHED_SUBSCRIPTIONS_ERROR,
        payload: err
      });
    });
  };
};


// WEBPACK FOOTER //
// ./src/actions/user.js